import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'lodash';
import { SubHistoryModel } from "../models/subhistory.model";

@Pipe({ name: 'subhistory' })
export class SubHistoryPipe implements PipeTransform {
    transform(array: SubHistoryModel[], history_sequence: string) {
        let result: SubHistoryModel[] = [];

        result.push(..._.filter(array, row => row.history_sequence === history_sequence));

        return result; //.sort((a, b) => (this.parseToTime1(a.history_sequence) < this.parseToTime1(b.history_sequence)) ? -1 : 1);
    }
}